import React,{useEffect, useState, useRef} from 'react';
import './galleryVN.css';
import cross from'../../images/cross.png'

function GalleryVN({goMenu, gallery }) {
  const [pics, setPics] = useState();
  const [fullImg, setFullImg] = useState();
  const [opac, setOpac] = useState(0);
  const wrap = useRef(null);



useEffect(() => {
navigator.app.overrideButton("backbutton", true);
document.addEventListener("backbutton", goToMenu)

return () => window.removeEventListener("backbutton", goToMenu);
});
  useEffect(() => {
    async function start(){
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
    wrap.current.style.zIndex = 0;
    setPics(Array.from(gallery.entries()));
      }
      start();
},[]);

async function openImg(e){
  setFullImg(e.target.src);
  await changeOnOff(false, setOpac);
}

async function closeImg(){
  wrap.current.style.zIndex = 12;
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  setFullImg(undefined);
}


  async function goToMenu(){
    wrap.current.style.zIndex = 15;
    await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
    goMenu();
  }
  function changeSetting(obj, setting, changeTo, um, speed, char){
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      //
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }else{
        i = Math.round(parseFloat(parent[prop]));
      }
      let slowDownTrigger = 0;
    //  if(char){//delete
    //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
    //}
    //  let slowDownCounter=0;
      let slower = 8;
      change();
    function change(){
      //slowDownCounter++;
    //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
    //    slower+=3; //slower of char
    //  }
    //  console.log(slower);
      if(i>changeTo){
        i-=speed;
        if(i<changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
  setTimeout(change, slower);
  return;
  }
  });
  }

  function changeOnOff(toLow, setter){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.07;
      setter(op);
      setTimeout(ChangetoLow, 5);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.02;
    setter(op);
    setTimeout(change, 5);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }


return(
<div className='menu'>
{fullImg && <div className="fullScreen" style={{opacity:opac}}>
<img onClick={closeImg} src={cross} style={{cursor:"pointer"}}/>
<div><img src={fullImg}/></div></div>
}
<div className="switchVN">
<div className="arrowBack" style={{position:"absolute",top:"-14px"}} onClick={goToMenu}>
    <div></div>
</div>
<h2>Gallery</h2>
</div>
<div className='clickWrap' id='wrap' ref={wrap} style={{opacity:1,zIndex:15}}></div>
<div className="galleryBlurTopVN"></div>
<div className="galleryBlurBottomVN"></div>
<div className="galleryVN">
{pics && pics.map((item,index)=>{
  if(item[1] === "1"){
  return (
    <div className='image' onClick={openImg} style={{cursor:"pointer"}} key={index}>{item[0] && <img src={item[0]}/>}</div>
  )
}else if(item[1].includes('Chapter')){
    return (
<h2 style={{color:"#fff"}} key={index}>{item[1]}</h2>
);
}else{
  return (
    <div className='image' key={index}>{item[0] && <img src={item[0]} className='blur'/>}</div>
  )
}
})}
{/*<div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={juliaBathTeasing} className='blurT'/></div>}
{<div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={juliaSpankedAss} className='blurT'/></div>}
{<div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img80} className='blurT'/></div>}
{<div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img95} className='blurT'/></div>}
{<div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img91} className='blurT'/></div>}
*/}
</div>
</div>
);

}

export default GalleryVN;
